import React from "react"
import { BoxProps } from "@mui/material"
import FakeMaterialBox from "./FakeMaterialBox"

const FlexBox = React.forwardRef<HTMLDivElement, BoxProps>((props, ref) => {
    return <FakeMaterialBox display="flex" {...props} ref={ref} />
})

export default FlexBox
